(ns app.front.view.group.admin.import.licence
  (:require [app.domain.business.model :as business-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.municipality.model :as municipality-model]
            [app.front.view.group.admin.import.common :as import-session-common]
            [app.front.view.group.admin.subs :as gas]
            [core.front.config :as front-config]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::selectable-licence-statuses
  :<- [::import-session-common/root-config]
  (fn [root-config _]
    (when (-> root-config :group.config/target #{:permit-type/L})
      [:licence.state/active
       :licence.state/revoked
       :licence.state/expired])))

(rf/reg-sub ::selectable-business-types
  :<- [::front-config/config]
  :<- [::gas/group-tr]
  (fn [[config tr]]
    (->> config
         :business-types
         (sort-by (comp tr vector)))))

(defmethod import-session-common/mapping-settings :data-import.mapping/licence-status
  [props]
  [(import-session-common/string-to-value-mapping-settings :data-import.mapping/licence-status
                                                           ::selectable-licence-statuses
                                                           identity
                                                           identity)
   props])

(defmethod import-session-common/mapping-settings :data-import.mapping/municipality
  [props]
  [(import-session-common/string-to-value-mapping-settings
     :data-import.mapping/municipality
     ;; TODO: move to common
     ::import-session-common/selectable-municipalities
     :db/id
     municipality-model/municipality-name)
   props])

(defmethod import-session-common/mapping-settings :licence/category-group-config
  [props]
  [(import-session-common/string-to-value-mapping-settings
     :licence/category-group-config
     ::import-session-common/selectable-categories
     :db/id
     config-model/localized-name)
   props])

(defmethod import-session-common/mapping-settings :data-import.mapping/holder-business-type
  [props]
  [(import-session-common/string-to-value-mapping-settings
     :data-import.mapping/holder-business-type
     ::selectable-business-types
     identity
     identity)
   props])

(defmethod import-session-common/mapping-settings :data-import.mapping/holder-business-subdivision
  [props]
  [(import-session-common/string-to-value-mapping-settings
     :data-import.mapping/holder-business-subdivision
     ::front-config/system-country-subdivisions
     identity
     #(keyword "subdivision" %))
   props])

(defmethod import-session-common/entity-href :import-session.type/licence
  [_ entity]
  (case (:entity/type entity)
    :entity.type/licence
    (href/href :view/licence {:group-id   (-> entity :domain/authority-group :group/id)
                              :licence-id (-> entity :licence/id)})
    ;; In the error/warning table we might also refer to business entities
    :entity.type/business
    (href/href :view/business {:business-id (-> entity :db/id)})
    nil))

(defmethod import-session-common/entities-cols :import-session.type/licence [_]
  [[:licence/id
    :licence/id]
   [:licence/address
    (fn [licence]
      (-> licence
          :licence/workspaces
          first
          :workspace/address))]
   [:licence/category-group-config
    (fn [licence]
      (let [lang (<sub [:language])]
        (-> licence
            :licence/category-group-config
            (config-model/localized-name lang))))]
   [:licence/issued-to
    (fn [licence]
      (let [lang (<sub [:language])]
        (-> licence
            :licence/issued-to
            (business-model/format-name lang))))]
   [:licence/valid-from
    (import-session-common/get-time-fn :licence/valid-from)]
   [:licence/valid-to
    (import-session-common/get-time-fn :licence/valid-to)]])
